import {
  Address,
  Annotation,
  CodeableConcept,
  Coding,
  ContactPoint,
  FhirDateTime,
  HumanName,
  FhirIdentifier,
  Period,
  Quantity,
  Range,
  Ratio,
  Timing,
} from '../fhirResourceParsers/Types';

import { ParserSupportedFhirTypes, ParserConfig } from './jmesFhirTypes';

export const fhirTypesWithMomentConfig = ['dateTime', 'period', 'timing'];

export type FhirTypeParserMap = {
  [key in ParserSupportedFhirTypes]: ParserConfig;
};

export const fhirTypeParserMap: FhirTypeParserMap = {
  address: {
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    Parser: Address,
    display: 'Address',
  },
  annotation: {
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    Parser: Annotation,
    display: 'Annotation',
  },
  codeableConcept: {
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    Parser: CodeableConcept,
    display: 'Codeable Concept',
  },
  coding: {
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    Parser: Coding,
    display: 'Coding',
  },
  contactPoint: {
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    Parser: ContactPoint,
    display: 'Contact Point',
  },
  dateTime: {
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    Parser: FhirDateTime,
    display: 'DateTime',
  },
  humanName: {
    Parser: HumanName,
    display: 'Human Name',
  },
  identifier: {
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    Parser: FhirIdentifier,
    display: 'Identifier',
  },
  period: {
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    Parser: Period,
    display: 'Period',
  },
  quantity: {
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    Parser: Quantity,
    display: 'Quantity',
  },
  range: {
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    Parser: Range,
    display: 'Range',
  },
  ratio: {
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    Parser: Ratio,
    display: 'Ratio',
  },
  timing: {
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    Parser: Timing,
    display: 'Timing',
  },
};

export const fhirTypesAsSelectOptions = Object.keys(fhirTypeParserMap).map(
  key => {
    const type = fhirTypeParserMap[key as ParserSupportedFhirTypes];
    return {
      value: key,
      display: type.display,
    };
  },
);
